import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';

const Imprint = () => {
  return (
    <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
      <SEO
        title="Imprint"
        description="Legal information and site operator details for AlienProduction."
        canonical="/imprint"
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl font-extrabold text-zinc-950 uppercase tracking-tight mb-12">
          Imprint (Aviso Legal)
        </h1>

        <div className="prose prose-zinc max-w-none space-y-12 text-zinc-600">
          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              Who owns and operates this website?
            </h2>
            <p className="leading-relaxed whitespace-pre-line text-lg">
              Mathias Deppe<br />
              Nemesi Valls 42<br />
              08210 Barberá del Vallés<br />
              Spain
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              Contact
            </h2>
            <p className="leading-relaxed">
              <strong>Email:</strong>{' '}
              <a
                href="mailto:contact@alienproduction.store"
                className="text-zinc-950 hover:underline"
              >
                contact@alienproduction.store
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              Tax Identification
            </h2>
            <p className="leading-relaxed">
              <strong>NIF/NIE:</strong> [Y8187448Z]
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-zinc-950 mb-4 uppercase">
              Dispute Resolution
            </h2>
            <p className="leading-relaxed">
              The European Commission provides a platform for online dispute
              resolution (OS):{' '}
              <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                className="text-zinc-950 underline ml-1"
              >
                https://ec.europa.eu/consumers/odr
              </a>
              . We are not obliged or willing to participate in a dispute
              settlement procedure before a consumer arbitration board.
            </p>
          </section>
        </div>
      </motion.div>
    </div>
  );
};

export default Imprint;